<script>
  import { modalFocus } from '../lib/modal.js';
  export let title;
  export let subtitle = '';
  export let busy = false;
  export let wide = false;
  export let variant = 'inventory';
  export let inactive = false;
  export let onClose;
</script>

<button class="inventory-modal-backdrop" disabled={busy} aria-label={'Cerrar ' + title} on:click={onClose}></button>
<div class="inventory-modal inventory-surface" class:wide class:analysis={variant === 'analysis'} class:plain={variant === 'plain'} inert={inactive} aria-hidden={inactive ? 'true' : undefined} use:modalFocus role="dialog" aria-modal="true" aria-label={title} tabindex="-1"
  on:keydown={event => { if (event.key === 'Escape') { event.stopPropagation(); if (!busy) onClose(); } }}>
  <header class="inventario-admin-header"><div><h2>{title}</h2>{#if subtitle}<small>{subtitle}</small>{/if}</div><button type="button" class="text-button" disabled={busy} aria-label={'Cerrar ' + title} on:click={onClose}>×</button></header>
  <div class="inventory-modal-body"><slot /></div>
</div>
